import React from 'react';
import update from 'immutability-helper';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
import moment from 'moment';

export default class Scheduler extends React.Component {

    constructor(props) {
        super(props);
        if(props.schedules.length){
            this.state = {
                schedules: props.schedules,
                // errorClass: false
            };
        } else {
            this.state = {
                schedules: [{ start_date: moment(), end_date: ''}],
                // errorClass: false
            };
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.schedules !== this.props.schedules){
            this.setState({schedules:nextProps.schedules});
        }
    }

    handleRemove(event, i) {
        this.setState(() => ({
            schedules: update(this.state.schedules, { $splice: [[i, 1]] } )
        }), () => {
            this.props.onChange(this.state.schedules)
        })
    }

    handleAdd(event, i) {
        let item = {start_date: '', end_date: ''};
        this.setState(() => ({
            schedules: update(this.state.schedules, { $push: [item] })
        }), () => {
            this.props.onChange(this.state.schedules)
        });
    }

    handleDateChange(newvalue, i, name) {
        if(name == 'end_date') {
            let start_date = this.state.schedules[i]['start_date'];
            if(!moment.isMoment(start_date)) var compare_date = moment(new Date(start_date) + 'Z');
            else var compare_date = start_date; 
            if( compare_date < newvalue ){
                this.setState(() => ({
                    schedules: update(this.state.schedules, { [i]: { [name] : {$set: newvalue} }  })
                }), () => {
                    this.props.onChange(this.state.schedules)
                })
            }
        } else {
            this.setState(() => ({
                schedules: update(this.state.schedules, { [i]: { [name] : {$set: newvalue} }  })
            }), () => {
                this.props.onChange(this.state.schedules)
            })
        }
    }

    render() {
        let render;
        if (this.state.schedules.length) {
            render = this.state.schedules.map((e, i) => {
                let value_render = '';
                if(e.start_date) { 
                    if(!moment.isMoment(e.start_date)){
                        var discount_start = moment(new Date(e.start_date) + 'Z');
                    } else {
                        var discount_start = e.start_date;
                    }
                } else { 
                    var discount_start = '';
                }
                if(e.end_date) {
                    if(!moment.isMoment(e.end_date)){
                        var discount_end = moment(new Date(e.end_date) + 'Z');
                    } else {
                        var discount_end = e.end_date;
                    }
                } else {
                    var discount_end = '';
                }
                value_render = (
                    <div className="awdp_repeat date_repeat clearfix">
                        <div className="awdp_half">
                            { i == 0 ? <label className="form-label">From Date</label> : '' }
                            <DatePicker
                                selected={discount_start}
                                name="start_date"
                                onChange={(newvalue) => {
                                    this.handleDateChange(newvalue, i, 'start_date')
                                }}
                                showTimeSelect 
                                selectsStart
                                autoComplete="off"
                                startDate={discount_start}
                                endDate={discount_end}
                                dateFormat="MMMM DD, YYYY HH:mm"
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                />
                        </div>
                        <div className="awdp_half">
                            { i == 0 ? <label className="form-label">To Date</label> : '' }
                            <DatePicker
                                selected={discount_end}
                                name="end_date"
                                onChange={(newvalue) => {
                                    this.handleDateChange(newvalue, i, 'end_date')
                                }}
                                showTimeSelect 
                                selectsEnd
                                autoComplete="off"
                                startDate={discount_start}
                                endDate={discount_end}
                                // className={this.state.errorClass ? 'errorField' : ''}
                                dateFormat="MMMM DD, YYYY HH:mm"
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                />
                        </div>
                    </div>
                );
                return (
                    <div className="awdp_group date_group clearfix">
                        {value_render}
                       
                        { i != 0 ?
                            <button className="awdp_add awdp_remove sch_remove" title="Remove" onClick={(event) => {
                                this.handleRemove(event, i);
                            }}></button>
                        : '' }

                        { i == (this.state.schedules.length - 1) ?
                            <button className="awdp_add sch_add" title="Add" onClick={(event) => {
                                this.handleAdd(event, i);
                            }}></button>
                        : '' }

                    </div>
                );
            });
        }

        return (
            <div>
                {render}
            </div>
        );
    }
}